import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class PlaguedForest1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.PLAGUED_FOREST1;
}

export default PlaguedForest1PoiTileEntity;
